// constants
import WalletConnectProvider from "@walletconnect/web3-provider";
import Web3 from "web3";
import Web3Modal from "web3modal";
// log
import { fetchData } from "../data/dataActions";

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    
    options: {
      rpcUrl: "https://rpc-mumbai.maticvigil.com/",
    },
  },
};

const web3Modal = new Web3Modal({
  theme:"dark",
  network: process.env.REACT_APP_modalNetwork, // optional
  cacheProvider: true, // optional
  providerOptions, // required
});

const connectRequest = () => {
  return {
    type: "CONNECTION_REQUEST",
  };
};

const connectSuccess = (payload) => {
  return {
    type: "CONNECTION_SUCCESS",
    payload: payload,
  };
};

const connectFailed = (payload) => {
  return {
    type: "CONNECTION_FAILED",
    payload: payload,
  };
};

const updateAccountRequest = (payload) => {
  return {
    type: "UPDATE_ACCOUNT",
    payload: payload,
  };
};

export const connect = () => {
  return async (dispatch) => {
    dispatch(connectRequest());
    let wallet =  await web3Modal.providerController.injectedProvider
    if(wallet === null){
      return false
    }else{
      
      const provider = await web3Modal.connect();
      let web3 = new Web3(provider);
      const accounts = await web3.eth.getAccounts();
      const chainId = await web3.eth.getChainId();
      if (
        80001 == chainId
      ) {
       
        dispatch(
          connectSuccess({
            account: accounts[0],
           
            web3,
          })
        );
        // Add listeners start
        provider.on("accountsChanged", (accounts) => {
          dispatch(updateAccount(accounts[0]));
        });
        provider.on("chainChanged", () => {
          clearCache();
        });
        // Add listeners end
      } else {
        web3Modal.clearCachedProvider();
        dispatch(
          connectFailed("Change network to " + "Mumbai Testnet")
        );
      }
      return true
    }
  };
};

export const clearCache = () => {
  web3Modal.clearCachedProvider();
  window.location.reload();
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account: account }));
    dispatch(fetchData(account));
  };
};

export const checkConnection = (dispatch) => {
  if (web3Modal.cachedProvider) {
    dispatch(connect())
  }
}
